/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.6.4",
    versionName: "0.3.0-nightly.2026.6.4",
    versionChannel: "nightly",
    buildDate: "2026-06-04T00:46:51.323Z",
    commitHash: "346f5fd59490efe9aa8d22df38012684acb342f4",
};
